export enum ReceivableStatus {
	PENDING 		= { code: 'PENDING', description: 'RECEIVABLE.PENDING', color: 'primary', icon: 'md-time' } as any,
	CANCELED 		= { code: 'CANCELED', description: 'RECEIVABLE.CANCELED', color: 'dark', icon: 'md-close-circle' } as any,
	PAID 			= { code: 'PAID', description: 'RECEIVABLE.PAID', color: 'green', icon: 'md-checkmark-circle' } as any,
	PAID_TO_PLACE 	= { code: 'PAID_TO_PLACE', description: 'RECEIVABLE.PAID_TO_PLACE', color: 'green', icon: 'md-checkmark-circle' } as any,
}



// WEBPACK FOOTER //
// ./src/app/pages/receivables/enums/receivable-status.enum.ts